import { render, staticRenderFns } from "./CheckoutLoyaltyCard.vue?vue&type=template&id=6bf4b94e&scoped=true&lang=pug&"
import script from "./CheckoutLoyaltyCard.vue?vue&type=script&lang=js&"
export * from "./CheckoutLoyaltyCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutLoyaltyCard.vue?vue&type=style&index=0&id=6bf4b94e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4b94e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow,VSkeletonLoader,VSpacer})
